import { Navigate } from 'react-router-dom';
import { JSX } from 'react';
import { useAuth } from '../auth/AuthProvider';

interface Props {
  children: JSX.Element;
}

export default function ProtectedRoute({ children }: Props) {
  const { isAuthenticated, isInitializing } = useAuth();
  if (isInitializing) return null;
  return isAuthenticated ? children : <Navigate to="/login" replace />;
}
